import { useQuery } from '@tanstack/react-query';

import { queryFn } from './portfoliosQueryFn';

export const QUERY_KEY = ['PORTFOLIOS'] as const;

export function usePortfolios({ enabled = true } = {}) {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn,
    enabled,
    retry: 1,
    staleTime: 3600000,
    meta: {
      tags: ['portfolio'],
    },
  });
}
